module.exports = {
          srcSet: __webpack_public_path__ + "public/images/b25cc6d4c6c3c46cd41f7400fdb9c67c-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/b25cc6d4c6c3c46cd41f7400fdb9c67c-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/b25cc6d4c6c3c46cd41f7400fdb9c67c-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/b25cc6d4c6c3c46cd41f7400fdb9c67c-1774.jpg"},
          
          width: 1774,
          height: 887
        }